import { findIndex } from 'lodash';
import { Plan } from '@zapier/design-system-revenue/src/types';

export const getCurrentPlanIndex = (
  plans: Plan[],
  currentPlanId: number,
  isFall2019Pricing: boolean = false
): number => {
  return isFall2019Pricing
    ? findIndex(
        plans,
        plan =>
          !!plan.taskLimitVariants.find(variant =>
            variant.intervals.find(interval => interval.id === currentPlanId)
          )
      )
    : findIndex(
        plans,
        plan => !!plan.intervals.find(interval => interval.id === currentPlanId)
      );
};
